import * as React from "react"

const SvgAdmin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 13.143q-1.475 0-2.488-1.013T8.5 9.643q0-1.476 1.012-2.488T12 6.143t2.488 1.012C15.501 8.167 15.5 8.66 15.5 9.643q0 1.474-1.012 2.487T12 13.143m0-2q.65 0 1.075-.425.425-.426.425-1.075 0-.65-.425-1.075T12 8.143t-1.075.425q-.425.424-.425 1.075 0 .65.425 1.075t1.075.425m0-6.875-6 2.25v4.725q0 1.35.375 2.625t1.025 2.4q1.05-.525 2.2-.825a9.5 9.5 0 0 1 2.4-.3q1.25 0 2.4.3t2.2.825q.65-1.125 1.025-2.4T18 11.243V6.518zm0 12.875q-.9 0-1.75.2a9 9 0 0 0-1.625.55q.724.75 1.575 1.3.85.55 1.8.85a7.4 7.4 0 0 0 1.8-.85 9 9 0 0 0 1.575-1.3 9 9 0 0 0-1.625-.55 7.6 7.6 0 0 0-1.75-.2m0 4.9a2 2 0 0 1-.625-.1Q8 20.818 6 17.78q-2-3.037-2-6.537V6.518q0-.625.362-1.125.363-.5.938-.725l6-2.25a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.224.938.725.362.5.362 1.125v4.725q0 3.5-2 6.537t-5.375 4.163a2 2 0 0 1-.625.1" />
  </svg>
)
export default SvgAdmin
